import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ynejoye from "../assets/homepage/Yne&Joy.svg"; // Import the favicon

const TitleFavicon = () => {
    const location = useLocation(); // Get current route

    useEffect(() => {
        if (location.pathname === "/") {
            document.title = "Yne&Joy";
            updateFavicon(ynejoye); // Set favicon for Yne&Joy
        }
    }, [location.pathname]); // Removed `navigate` as it's unnecessary

    // Function to update favicon
    const updateFavicon = (faviconPath) => {
        let favicon = document.querySelector("link[rel='icon']");
        if (!favicon) {
            favicon = document.createElement("link");
            favicon.rel = "icon";
            document.head.appendChild(favicon);
        }
        favicon.href = faviconPath; // Correctly set favicon
    };

    return null; // No UI needed
}

export default TitleFavicon;
